<template>
  <div class="container">
    <a-form :model="handleList" class="search-form" @submit="handleList">
      <a-form-item name="status">
        <div class="form-item-content">
          <div class="label">会员状态：</div>
          <a-select style="width: 100px" v-model:value="listRequest.status">
            <a-select-option :value="1">可用</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </div>
      </a-form-item>
      <a-form-item name="origin">
        <div class="form-item-content">
          <div class="label">会员来源：</div>
          <a-select style="width: 150px" v-model:value="listRequest.origin">
            <a-select-option :value="1">微信小程序</a-select-option>
          </a-select>
        </div>
      </a-form-item>
      <a-form-item name="content">
        <div class="form-item-content">
          <div class="label">搜索内容：</div>
          <a-input
            placeholder="OpenId/用户名/电话号码"
            v-model:value="listRequest.content"
          />
        </div>
      </a-form-item>
      <a-form-item name="create_at">
        <div class="form-item-content">
          <div class="label">创建时间：</div>
          <a-date-picker
            placeholder="选择时间"
            format="YYYY-MM-DD HH:mm:ss"
            :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }"
            @change="createAtChange"
          />
        </div>
      </a-form-item>
      <a-form-item name="update_at">
        <div class="form-item-content">
          <div class="label">修改时间：</div>
          <a-date-picker
            placeholder="选择时间"
            format="YYYY-MM-DD HH:mm:ss"
            :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }"
            @change="updateAtChange"
          />
        </div>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">搜索</a-button>
        <a-button style="margin-left: 10px" @click="resetSearch">重置</a-button>
      </a-form-item>
    </a-form>
  </div>
  <div class="container">
    <a-table
      :columns="columns"
      :data-source="userList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        defaultPageSize: listRequest.size,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      }"
      :scroll="{ x: 1000, y: 800 }"
      bordered
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'status'">
          <a-tag v-if="record.status === 1" color="green">可用</a-tag>
          <a-tag v-if="record.status === 2" color="red">禁用</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'avatar'">
          <a-image
            :src="ToImage(record.avatar)"
            style="height: 60px; width: auto"
          />
        </template>
        <template v-else-if="column.dataIndex === 'origin'">
          <span v-if="record.status === 1">微信小程序</span>
        </template>
        <template v-else-if="column.dataIndex === 'leave_time'">
          <span
            >{{ dayjs(record.leave_time).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'come_time'">
          <span
            >{{ dayjs(record.come_time).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'update_at'">
          <span
            >{{ dayjs(record.update_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="handleUpdate(record)"
            type="primary"
            :style="{ marginRight: '8px' }"
            >编辑
          </a-button>
          <!--a-button
            @click="submitDelete(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }"
            >删除
          </a-button-->
          <a-button
            @click="submitDrop(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
            }"
            >彻底删除
          </a-button>
        </template>
      </template>
    </a-table>
    <a-modal
      v-model:open="openUpdate"
      title="修改会员数据"
      @ok="submitUpdate"
      cancelText="取消"
    >
      <a-form :model="updateRequest" style="margin-top: 20px">
        <a-form-item label="用户名">
          <a-input v-model:value="updateRequest.name" />
        </a-form-item>
        <a-form-item label="离家时间">
          <a-date-picker
            placeholder="选择时间"
            format="YYYY-MM-DD HH:mm:ss"
            :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }"
            @change="levelTimeChange"
          />
        </a-form-item>
        <a-form-item label="归家时间">
          <a-date-picker
            placeholder="选择时间"
            format="YYYY-MM-DD HH:mm:ss"
            :show-time="{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }"
            @change="comeTimeChange"
          />
        </a-form-item>
        <a-form-item label="可用状态">
          <a-select v-model:value="updateRequest.status">
            <a-select-option :value="1">可用</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model:value="updateRequest.is_delete">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">回收站</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="用户头像">
          <File-Upload v-model="updateRequest.avatar" style="display: block" />
          <a-image
            v-if="updateRequest.avatar !== ''"
            :src="ToImage(updateRequest.avatar)"
            style="max-height: 150px; display: block; margin-top: 10px"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { User } from "@/api/models/user/User";
import { UserUpdateRequest } from "@/api/models/user/UserUpdateRequest";
import { UserService } from "@/api/services/UserService";
import { UserListRequest } from "@/api/models/user/UserListRequest";
import { ToImage } from "@/utils/image";
import FileUpload from "@/components/FileUpload.vue";
import { Moment } from "moment";

dayjs.locale("zh-cn");

const total = ref<number>(0);

const listRequest = reactive<UserListRequest>({
  current: 1,
  size: 20,
  content: "",
  start_time: 0,
  end_time: 0,
});

const userList = ref<User[]>([{}]);

const handleList = async () => {
  const res = await UserService.ListAll(listRequest);
  if (res.code === 0) {
    userList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.start_time = 0;
  listRequest.end_time = 0;
  handleList();
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openUpdate = ref(false);

const updateRequest = reactive<UserUpdateRequest>({
  id: 0,
  name: "",
  balance: 0,
  status: 0,
  avatar: "",
  leave_time: 0,
  come_time: 0,
  is_delete: 1,
});

const levelTimeChange = (_: Moment, mode: string) => {
  updateRequest.leave_time = Date.parse(mode);
};

const comeTimeChange = (_: Moment, mode: string) => {
  updateRequest.come_time = Date.parse(mode);
};

const createAtChange = (_: Moment, mode: string) => {
  listRequest.start_time = Date.parse(mode);
};

const updateAtChange = (_: Moment, mode: string) => {
  listRequest.end_time = Date.parse(mode);
};

const handleUpdate = (record: User) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
  updateRequest.leave_time = Date.parse(record.leave_time);
  updateRequest.come_time = Date.parse(record.come_time);
};

const submitUpdate = async () => {
  const res = await UserService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: User) => {
  const res = await UserService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: User) => {
  const res = await UserService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "OpenId",
    dataIndex: "open_id",
    align: "center",
  },
  {
    title: "头像",
    dataIndex: "avatar",
    align: "center",
  },
  {
    title: "用户名",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "余额",
    dataIndex: "balance",
    align: "center",
  },
  // {
  //   title: "可用状态",
  //   dataIndex: "status",
  //   align: "center",
  // },
  {
    title: "离家时间",
    dataIndex: "leave_time",
    align: "center",
  },
  {
    title: "回家时间",
    dataIndex: "come_time",
    align: "center",
  },
  // {
  //   title: "来源",
  //   dataIndex: "origin",
  //   align: "center",
  // },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "修改时间",
    dataIndex: "update_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
    width: 300,
  },
];
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
}

.form-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  white-space: nowrap;
}
</style>
